/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as SegmentedControlDefault } from './segmented-control-default.story';
export { default as SegmentedControlFloating } from './segmented-control-floating.story';
export { default as SegmentedControlOnlyIcons } from './segmented-control-only-icons.story';
export { default as SegmentedControlSizes } from './segmented-control-sizes.story';
export { default as SegmentedControlDisabled } from './segmented-control-disabled.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import SegmentedControlDefaultSourceRaw from './segmented-control-default.story?raw';
import SegmentedControlDisabledSourceRaw from './segmented-control-disabled.story?raw';
import SegmentedControlFloatingSourceRaw from './segmented-control-floating.story?raw';
import SegmentedControlOnlyIconsSourceRaw from './segmented-control-only-icons.story?raw';
import SegmentedControlSizesSourceRaw from './segmented-control-sizes.story?raw';

export const SegmentedControlDefaultSource = removeLicenseHeader(
  SegmentedControlDefaultSourceRaw,
);
export const SegmentedControlFloatingSource = removeLicenseHeader(
  SegmentedControlFloatingSourceRaw,
);
export const SegmentedControlOnlyIconsSource = removeLicenseHeader(
  SegmentedControlOnlyIconsSourceRaw,
);
export const SegmentedControlSizesSource = removeLicenseHeader(
  SegmentedControlSizesSourceRaw,
);
export const SegmentedControlDisabledSource = removeLicenseHeader(
  SegmentedControlDisabledSourceRaw,
);
